import { z } from 'zod';
export const SessionTagIdSchema = z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/);
export const SessionTagBindingSchema = z
    .object({
    sessionId: z.string().guid(),
    tagId: SessionTagIdSchema,
    createdAt: z.string().datetime(),
})
    .strict();
export const SessionTagListResponseSchema = z
    .object({
    items: z.array(SessionTagBindingSchema),
})
    .strict();
export const SessionIdsByTagsRequestSchema = z
    .object({
    tagIds: z.array(SessionTagIdSchema).min(1).max(20),
    match: z.literal('all').prefault('all'),
})
    .strict();
export const SessionIdsByTagsResponseSchema = z
    .object({
    sessionIds: z.array(z.string().guid()),
})
    .strict();
//# sourceMappingURL=SessionTags.js.map